import WithdrawPage from '../../components/pages/accounts/WithdrawPage.vue'
export default {
  components: { WithdrawPage }
}
